<template>
  <div class="content_main" @scroll="handleScroll">
    <div class="banner animate__animated animate__bounceInLeft">
      <img src="./images/bannerPrdAndEdu.jpg" alt="">
    </div>
    <div class="animate__animated animate__fadeInUp">
      <div class="module-title">
		  产教融合
        <div class="mt_line"></div>
      </div>
      <div class="programme content">

		  <div class="programme_box">
			  <div>
				  <img src="./images/iconsNote_16.png" alt="">
			  </div>
			  <div>创新创业实训平台
			  </div>
		  </div>
		  <div class="programme_box">
			  <div>
				  <img src="./images/iconsNote_17.png" alt="">
			  </div>
			  <div>体验展示中心
			  </div>
		  </div>
		  <div class="programme_box">
			  <div>
				  <img src="./images/iconsNote_18.png" alt="">
			  </div>
			  <div>运营管理实训平台
			  </div>
		  </div>
		  <div class="programme_box">
			  <div>
				  <img src="./images/iconsNote_19.png" alt="">
			  </div>
			  <div>企业管理实训平台
			  </div>
		  </div>
		  <div class="programme_box">
			  <div>
				  <img src="./images/iconsNote_20.png" alt="">
			  </div>
			  <div>规划与产品设计实训平台
			  </div>
		  </div>
	  </div>
    </div>
    
    <div>
      <div class="module-title">
        部分案例
        <div class="mt_line"></div>
      </div>
      <div class="content hexagon_box">
        <hexagon v-for="item in hexagonList" :key="item.id" :title="item.title" :imageSrc="item.srcUrl" />
      </div>
    </div>
    <div>
      <footerPage />
    </div>
  </div>
</template>

<script>
import hexagon from '../../components/hexagon/hexagon'
import footerPage from '../../components/footer/footer'
export default {
  components:{
    hexagon,
    footerPage
  },
  data() {
    return {
      hexagonList:[
        {
          id:0,
          title:'浙江师范大学',
          srcUrl:require('./images/caseZJSFDX.jpg')
        },
        {
          id:1,
          title:'海南大学',
          srcUrl:require('./images/caseHNDX.jpg')
        },
        {
          id:2,
          title:'厦门大学',
          srcUrl:require('./images/caseXMDX.jpg')
        }
      ]
    }
  },
  methods: {
    handleScroll(e){
      let scrollTop = e.srcElement.scrollTop
      
    }
  },
}
</script>

<style lang='less' scoped>
@import url('../../assets/css/content.less');
.content_main{
  height: 100%;
  width: 100%;
  overflow-y: auto;
}
.banner{
  width: 100%;
  img{
    width: 100%;
    border: 0;
    display: block;
  }
}
.module-title {
  margin-top: 40px;
  margin-bottom: 40px;
  font-size: 26px;
  color: #0080cc;
  text-align: center;
  font-weight: normal;
}
.mt_line {
  width: 100%;
  height: 83px;
  margin-bottom: 20px;
  background: url('./../../../static/images/ai/btline.png') no-repeat center top;
}
.programme{
  margin-top: 2rem;
  width: 100%;
  display: flex;
  border-radius: 10px;
  flex-wrap: wrap;
  align-items: center;
  .programme_box{
    width: 20%;
    margin: 5% 2.5%;
    height: 60px;
    line-height: 60px;
    text-align: center;
    border-radius: 6px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    font-size: 18px;
    box-sizing: border-box;
    cursor: pointer;
    position: relative;
    div:first-child{
      position: absolute;
      width: 100px;
      height: 100px;
      border-radius: 50%;
      left: -50px;
      top: -50px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      img{
        width: 60%;
      }
    }
  }
}
.hexagon_box{
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding-bottom: 20px;
}
</style>
